import { useMemo } from 'react'
import { useParams } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { $api } from '../api/queryClient'
import { useBreadcrumbs } from '../hooks/useBreadcrumbs'
import { IssueBody } from './issues/IssueBody'
import { useLiveSubscription } from '../contexts/LiveEventsContext'

export function IssuePage() {
  const { org, uid } = useParams({ from: '/$org/issues/$uid' })
  const { t } = useTranslation('issues')

  // Live entity notifications: detail scope only. The realtime scope map
  // routes issue_comments audit events to the issues live entity (see
  // internal/realtime/scope.go), so comment create/edit/delete also refresh
  // this subscription for free.
  useLiveSubscription({ entity: 'issues', uid })

  const { data: issue } = $api.useQuery(
    'get',
    '/api/v1/organizations/{orgCode}/issues/{issueUid}',
    {
      params: { path: { orgCode: org, issueUid: uid } },
    }
  )

  const breadcrumbs = useMemo(
    () => [
      { title: t('common:nav.home'), path: `/${org}` },
      { title: t('common:nav.steering'), path: `/${org}/steering` },
      { title: issue?.title || t('common:status.loading') },
    ],
    [org, issue?.title, t]
  )
  useBreadcrumbs(breadcrumbs)

  return (
    <div className="container mx-auto py-8 max-w-5xl">
      <IssueBody orgCode={org} issueUid={uid} />
    </div>
  )
}
